module.exports = __webpack_public_path__ + "img/1190625755.803d5040.jpg";